import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from 'react-router-dom';
import { destinations } from '../data/Destination';
import deafultImage from "../assets/headerimg/dubaiwebp1.webp"

const DomesticPackages = () => {
    const navigate = useNavigate();
    return (
        <>
            {Array.isArray(destinations) && destinations.length > 0 && (
                <>
                    <div className="relative overflow-hidden " >
                        {/* decorative circles similar to screenshot */}
                        <div className="absolute top-8 left-8 w-24 h-24 rounded-full bg-indigo-800 opacity-20 mix-blend-screen pointer-events-none" />
                        <div className="absolute bottom-16 right-16 w-32 h-32 rounded-full bg-slate-700 opacity-20 mix-blend-screen pointer-events-none" />
                        <div className={`mt-6 max-lg:ml-6 mx-6 text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12`} data-wow-delay="0.1s"
                            style={{ boxShadow: ' 0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                        >
                            {/* Heading */}
                            <h1 className=" playfair-display font-extrabold py-[6px] px-2 max-lg:text-xl text-2xl text-white">
                                India Tour Packages
                            </h1>
                            {/* <h6 className="max-sm:text-sm px-3 text-[#D4AF37] ">Explore the Colors of India</h6> */}
                        </div>
                        <div className="flex justify-center items-center mb-5  relative w-[100%] max-sm:px-0 xl:mx-4 mx-0">
                            <Swiper
                                modules={[Pagination, Autoplay]}
                                spaceBetween={15}
                                slidesPerView={1}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 2,
                                        direction: "horizontal",
                                    },
                                    480: {
                                        slidesPerView: 2,
                                        direction: "horizontal",
                                    },
                                    640: {
                                        slidesPerView: 2,
                                        direction: "horizontal",
                                    },
                                    768: {
                                        slidesPerView: 3,
                                        direction: "horizontal",
                                    },
                                    1024: {
                                        slidesPerView: 4,
                                        direction: "horizontal",
                                    },
                                    1280: {
                                        slidesPerView: 5,
                                        direction: "horizontal",
                                    },
                                }}
                                loop={true}
                                // navigation={true}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                // pagination={{ clickable: true }} 
                                className=" relative flex flex-col w-full h-[35vh] max-xs:h-[25vh] cursor-pointer  max-sm:!p-[20px] md:!p-[11px] lg:!p-[16px] xl:!p-[16px]"
                            >
                                {destinations?.filter(d => d?.categories?.includes("domestic"))?.map((pkg, index) => (
                                    <SwiperSlide key={pkg.id || index}>
                                        <div
                                            className={`relative  bg-[#ffffff] border-1 border-[#D4AF37]      rounded-xl text-white flex flex-col items-center h-full`}
                                            style={{ boxShadow: '0px 0px 20px 5px  rgb(0 0 0 / 32%)' }}
                                            onClick={() => navigate(pkg?.link)}
                                        >
                                            {/* Left Side - Offer Image */}
                                            <div
                                                className="absolute w-full h-full  overflow-hidden rounded-xl cursor-pointer"
                                            >
                                                <img
                                                    src={pkg?.image || deafultImage}
                                                    alt={pkg?.title || "destination"}
                                                    loading="lazy"
                                                    className="w-full rounded-xl h-full object-cover hover:scale-110 transition duration-500"
                                                />
                                                <div className="absolute inset-0 bg-black opacity-50"></div>

                                            </div>
                                            {/* Right Side - Offer Details */}
                                            <div className="z-10  w-[100%] h-full ml-1 px-1  overflow-hidden flex items-start justify-end  flex-col">
                                                <h2 className="text-[#ffffff] text-start mb-0 text-[18px]  md:text-[18px] lg:text-lg xl:text-2xl font-semibold playfair-display">
                                                    {pkg?.name || "Destination"} Packages
                                                </h2>
                                                <p className="text-[12px]  md:text-[14px] lg:text-[14px] xl:text-[16px] text-white poppins ">
                                                    <span>
                                                        From{" "}
                                                        <span className="text-[14px]  md:text-[16px] lg:text-[16px] xl:text-[18px] font-bold">
                                                            ₹{pkg?.price || "N/A"}/-
                                                        </span>
                                                    </span>{" "}
                                                    <span className="text-[9px] sm:text-[10px] md:text-xs lg:text-sm">
                                                        Per Person
                                                    </span>
                                                </p>
                                            </div>
                                        </div>

                                    </SwiperSlide>
                                ))}
                            </Swiper>

                        </div>

                    </div>
                </>
            )}
        </>
    );
};

export default DomesticPackages;
